import { render, staticRenderFns } from "./assetTransfer.vue?vue&type=template&id=6709f077&scoped=true&"
import script from "./assetTransfer.vue?vue&type=script&lang=js&"
export * from "./assetTransfer.vue?vue&type=script&lang=js&"
import style0 from "./assetTransfer.vue?vue&type=style&index=0&id=6709f077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6709f077",
  null
  
)

export default component.exports